import React, { Fragment } from 'react';
import Layout from '@components/Layout';
import { Grid, Divider, Col, Row } from '@components/Grid';
import SEO from '@components/SEO';

const ShippingPolicy = ({
    data: {
        page: {
            frontmatter: { title, text },
        },
    },
}) => {
    return (
        <Layout>
            <SEO title={title} />
            <Grid>
                <Row>
                    <Col>
                        <h1>{title}</h1>
                        <div dangerouslySetInnerHTML={{ __html: text }} />
                    </Col>
                </Row>
            </Grid>
        </Layout>
    );
};

export const query = graphql`
    query ShippingPolicy($path: String!) {
        page: markdownRemark(frontmatter: { path: { eq: $path } }) {
            frontmatter {
                title: shipping_policy_title
                text: shipping_policy_text
            }
        }
    }
`;
export default ShippingPolicy;
